/**
 * Names the nth outgoing branch of a sub-step.
 *
 * The same string is the source handle id an admin drags from in the workflow
 * editor and the `fromKey` the runtime step sends to nextSubStep, which is how
 * a saved branch is matched back to the choice it came from. Any step that
 * forks uses this, so a key must stay tied to a fixed position rather than to
 * whichever choices happen to be enabled.
 */
export const branchKey = (index: number) => `branch-${index}`;
